import React from 'react';
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';
import { useSelector } from "react-redux";
import ActionConfirmForm from '../common/ActionConfirmForm';
import './CtaItem.scss';

const ReactSwal = withReactContent(Swal);

const CtaItem = props => {
  const users = useSelector(({ settings }) => settings.users || []);

  const onDeleteCtaItem = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <ActionConfirmForm
          onConfirm={ReactSwal.clickConfirm}
          onClose={ReactSwal.clickCancel}
          title="Delete Call-To-Action"
          question="Are you sure you want to delete this Call-To-Action?"
        />
      )
    })
    .then(async result => {
      if (result.value) {
        props.onDelete();
      }
    });
  };

  return (
    <div className="cta-item">
      <div className="cta-item-content">
        <div className="cta-avatar">
          <img src={props.avatar} alt="avatar" />
        </div>
        <div className="name-message">
          <div className="name">{props.data.name}</div>
          <div className="message">{props.data.message}</div>
        </div>
        {/* <div className="name">{props.data.name}</div>
        <div className="message">{props.data.message}</div> */}
        <div className="action-button-container">
        <a
          className="action-button"
          href={props.data.targetUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {props.data.buttonText}
        </a>
        </div>
        <div className="description">
          {/* Added a specific class to help handle long URLs */}
          <div className="content target-url mb-2">{props.data.targetUrl}</div>
          <div className="createdBy">
            {users.find(u => u.userId === props.data.userId).name}
          </div>
          {/* <div className="content">{moment(props.data.createdAt).format('YYYY-MM-DD')}</div> */}
        </div>
      </div>
      <div className="actions">
        <FontAwesomeIcon onClick={props.onEdit} icon={faPen} />
        <FontAwesomeIcon onClick={onDeleteCtaItem} icon={faTrash} />
      </div>
    </div>
  );
};

export default CtaItem;